import { AutomationForgeElementType } from "@redotech/redo-content-builder-common/forge/marketing-automation-forge-types";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  MarkerType,
} from "@xyflow/react";
import { DropZone } from "../nodes/drop-zone-node";
import * as EdgeCSS from "./edge.module.css";

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
}: {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  data?: {
    idFrom: string;
    idTo?: string;
    conditionSide?: boolean;
    edgeId?: string;
    elementDropped(
      elementType: AutomationForgeElementType,
      idFrom: string,
      idTo?: string,
      conditionSide?: boolean,
      edgeId?: string,
    ): void;
  };
}) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 20,
  });

  return (
    <>
      <BaseEdge
        className={EdgeCSS.line}
        id={id}
        markerEnd={MarkerType.Arrow}
        path={edgePath}
      />
      {data && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: "all",
            }}
          >
            {DropZone(
              data.idFrom,
              data.elementDropped,
              data.idTo,
              data.conditionSide,
              false, // isNode parameter
              data.edgeId,
            )}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
